import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'
import images_modal from '../../../assets/images/games/modal/images'

const ec = LOCALE === "es-EC"
const arg = LOCALE === "es-AR"

export let textCountry ={}

if (arg) {
    textCountry = {
        text1: '¡Demostrá que sos la mejor!',
        text2: 'Dejá caer las piezas y ve rellenando ',
        text3: 'Usá las flechas de tu teclado para',
        text4: 'mové',
        text5: 'girá',
        text6: 'Debés',
        text7: 'aprovechalo',
        text8: 'Evitá',
        text9: 'recogé',
        text10: 'podás',
        text11: 'recogelos',
        text12: 'Usá',
        text13: 'Arrastrá',
        text14: 'intercambiá',
        text15: 'juntés ',
        text16: 'debés',
        text17: 'hacia',
        text18: 'Usá el pad de tu pantalla para mover las piezas en el escenario.',
    }
}else{
    textCountry = {
        text1: '¡Demuestra que eres la mejor!',
        text2: 'Deja caer las piezas y ve rellenando',
        text3: 'Usa las flechas de tu teclado para',
        text4: 'mueve',
        text5: 'gira',
        text6: 'Debés',
        text7: 'aprovéchalo',
        text8: 'Evita',
        text9: 'recoge',
        text10: 'puedas',
        text11: 'recógelos',
        text12: 'Usa',
        text13: 'Arrastra',
        text14: 'intercambia',
        text15: 'juntes ',
        text16: 'debes',
        text17: '',
        text18: 'Usa el pad de tu pantalla para mover las piezas en el escenario.',

    }
}

export const ReplicaImagePCTetris = () => {
    let image;
    if (arg) {
        image = images_modal.tetris_preview_2_arg
    }else{
        image = images_modal.tetris_preview_2
    }
    return (
        <img src={image} />
    )
}
export const ReplicaImageMBTetris = () => {
    let image;
    if (arg) {
        image = images_modal.tetris_preview_mb_3_arg
    }else{
        image = images_modal.tetris_preview_mb_3
    }
    return (
        <img src={image}/>
    )
}
export const ReplicaImageMBSnake = () => {
    let image;
    if (arg) {
        image = images_modal.snake_preview_1_arg
    }else{
        image = images_modal.snake_preview_1
    }
    return (
        <img src={image}/>
    )
}
export const ReplicaImagePCLinea3 = () => {
    let image;
    if (arg) {
        image = images_modal.linea3_preview_1_arg
    }else{
        image = images_modal.linea3_preview_1
    }
    return (
        <img src={image} />
    )
}
export const ReplicaImage1MBLinea3 = () => {
    let image;
    if (arg) {
        image = images_modal.linea3_preview_1_mb_arg
    }else{
        image = images_modal.linea3_preview_1_mb
    }
    return (
        <img src={image}/>
    )
}

export const ReplicaImage2MBLinea3 = () => {
    let image;
    if (arg) {
        image = images_modal.linea3_preview_2_mb_arg
    }else{
        image = images_modal.linea3_preview_2_mb
    }
    return (
        <img src={image}/>
    )
}
